import { useEffect, useState } from "react";
import api from "@/api/client";
import { Wallet } from "lucide-react";

/**
 * CostCenterSelect — native <select> populated from /cost-centers?active=true.
 * Marks selection mandatory in the form (backend also enforces).
 */
export default function CostCenterSelect({ value, onChange, required = false, testidPrefix = "out" }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/cost-centers", { params: { active: true } });
        setItems(data || []);
      } catch (_e) { /* silent */ }
    })();
  }, []);

  return (
    <label className="block">
      <span className="overline flex items-center gap-1">
        <Wallet size={12} /> Cost Center {required && <span className="text-primary">*</span>}
      </span>
      <select
        data-testid={`${testidPrefix}-cost-center`}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        className="mt-1 w-full h-10 px-3 rounded-md border border-input bg-background text-sm"
      >
        <option value="" disabled>
          {items.length === 0 ? "No active cost centers — add one under Settings" : "Select cost center…"}
        </option>
        {items.map((cc) => (
          <option key={cc.id} value={cc.id}>
            {cc.name} · {cc.department}
          </option>
        ))}
      </select>
      {items.length === 0 && (
        <div className="text-[10px] text-muted-foreground mt-1">
          Ask your admin to add cost centers under Settings → Cost Centers.
        </div>
      )}
    </label>
  );
}
